import React from "react";
import {
    Box,
    Heading,
    Stat,
    StatLabel,
    StatNumber,
    SimpleGrid,
    Text,
    Flex,
    List,
    ListItem,
    Avatar,
    Progress,
    CircularProgress,
    CircularProgressLabel,
    Divider,
} from "@chakra-ui/react";
import { PieChart, Pie, Cell } from 'recharts';

function AttendanceCard({ attendanceData }) {
    const { present, absent, halfDay, late } = attendanceData;

    const totalDays = 28;
    const attendanceDataPie = [
        { name: "Present", value: present, color: "green" },
        { name: "Absent", value: absent, color: "red" },
        { name: "Half Day", value: halfDay, color: "yellow" },
        { name: "Late", value: late, color: "orange" },
    ];
    return (
        <Box bg="white" p={6} borderRadius={12} borderWidth="1px" w="100%">
            <Heading size="md" mb={4}>
                Attendance
            </Heading>
            <Text fontSize="sm" mb={2}>14 May 2024 - 21 May 2024</Text>
            <Flex justify="space-between" mb={4} gap={2}>
                {["M", "T", "W", "T", "F"].map((day, index) => (
                    <Text
                        key={index}
                        bg={index < 5 ? "green.400" : "red.400"}
                        color="white"
                        borderRadius="md"
                        px={2}
                        py={1}
                        textAlign="center"
                        w="100%"
                    >
                        {day}
                    </Text>
                ))}
            </Flex>

            <SimpleGrid columns={4} spacing={4} mb={4}>
                <Stat>
                    <StatLabel>Present</StatLabel>
                    <StatNumber>{present}</StatNumber>
                </Stat>
                <Stat>
                    <StatLabel>Absent</StatLabel>
                    <StatNumber>{absent}</StatNumber>
                </Stat>
                <Stat>
                    <StatLabel>Half Day</StatLabel>
                    <StatNumber>{halfDay}</StatNumber>
                </Stat>
                <Stat>
                    <StatLabel>Late</StatLabel>
                    <StatNumber>{late}</StatNumber>
                </Stat>
            </SimpleGrid>

            <Divider />

            <Flex justify="center" mt={4}>
                <PieChart width={200} height={200}>
                    <Pie
                        data={attendanceDataPie}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={80}
                        fill="#8884d8"
                        paddingAngle={5}
                        dataKey="value"
                    >
                        {attendanceDataPie.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                </PieChart>
            </Flex>
        </Box>
    );
}

function BestPerformersCard({ performers }) {
    return (
        <Box bg="white" p={6} borderRadius={12} boxShadow="md" w="100%">
            <Heading size="md" mb={4}>
                Best Performers
            </Heading>
            {performers.map((performer) => (
                <Flex key={performer.class} align="center" mb={4}>
                    <Text w="30%" fontSize="md">
                        {performer.class}
                    </Text>
                    <Progress value={performer.percentage} size="md" colorScheme="blue" w="55%" />
                    <Text ml={4} fontSize="md" fontWeight="bold">
                        {performer.percentage}%
                    </Text>
                </Flex>
            ))}
        </Box>
    );
}

function StudentProgressCard({ studentData }) {
    return (
        <Box bg="white" p={6} borderRadius={12} boxShadow="md" w="100%">
            <Heading size="md" mb={4}>
                Student Progress
            </Heading>
            <List spacing={5}>
                {studentData.map((student) => (
                    <ListItem key={student.id} display="flex" alignItems="center">
                        <Avatar size="md" src={student.avatar} />
                        <Flex ml={4} justify="space-between" w="full" align="center">
                            <Box>
                                <Text fontSize="md" fontWeight="bold">
                                    {student.name}
                                </Text>
                                <Text fontSize="sm" color="gray.600">
                                    {student.class}
                                </Text>
                            </Box>
                            <Text fontSize="lg" fontWeight="bold">
                                {student.progress}%
                            </Text>
                        </Flex>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}

function Gra() {
    const attendanceData = {
        present: 25,
        absent: 2,
        halfDay: 0,
        late: 1,
    };

    const studentData = [
        {
            id: 1,
            name: "Susan Boswell",
            progress: 98,
            avatar: "https://randomuser.me/api/portraits/women/1.jpg",
            class: "Class III, B",
        },
        {
            id: 2,
            name: "Richard Mayes",
            progress: 98,
            avatar: "https://randomuser.me/api/portraits/men/1.jpg",
            class: "Class V, A",
        },
        {
            id: 3,
            name: "Veronica Randle",
            progress: 78,
            avatar: "https://randomuser.me/api/portraits/women/2.jpg",
            class: "Class V, B",
        },
    ];
    

    const bestPerformers = [
        { class: "Class IV, C", percentage: 80 },
        { class: "Class III, B", percentage: 54 },
        { class: "Class V, A", percentage: 7 },
    ];

    return (
        <Box p={{baswe:0,md:6}}>
            <SimpleGrid columns={{ base: 1, md: 1 }} spacing={6}>
                <AttendanceCard attendanceData={attendanceData} />
                {/* <BestPerformersCard performers={bestPerformers} /> */}
                {/* <StudentProgressCard studentData={studentData} /> */}

            </SimpleGrid>

        </Box>
    );
}

export default Gra;
